import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import IntegrationPartnerStore from 'stores/Model/Integration/IntegrationPartnerStore';
import OptionStore from 'stores/Model/Integration/Option/OptionStore';
import * as constants from 'Constants';
import { deserializeWithMappers } from 'stores/Utils';


class DetailsPageStore {

  @setter @observable integration;
  @setter @observable categoryOptions;
  @setter @observable integratedAppOptions;

  @setter @toggle @observable displayScreenshot;
  @setter @observable screenshotIndex;
  @setter @toggle @observable loaded;

  constructor() {
    this.reset();
  }

  reset() {
    this.integration = new IntegrationPartnerStore();
    this.categoryOptions = [];
    this.integratedAppOptions = [];

    this.displayScreenshot = false;
    this.screenshotIndex = 0;
    this.loaded = false;
  }

  getDeserializeMappers() {
    return [
      {"field": "integration", "accessor": "integration_partner", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": IntegrationPartnerStore},
      {"field": "categoryOptions", "accessor": "category_options", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": OptionStore},
      {"field": "integratedAppOptions", "accessor": "integrated_app_options", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": OptionStore},
    ];
  }

  @action deserialize(data) {
    deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @action setFields(data) {
    let self = this;
    for (var key in data) {
      let value = data[key];
      self[key] = value;
    }
  }

  @computed get screenshotsViews() {
    const images = [];
    this.integration.listing.screenshots.forEach((screenshot) => {
      images.push({
        source: screenshot.media.src,
      })
    })

    return images;
  }

  @computed get categorySelectOptions() {
    return this.categoryOptions.map((option) => {
      return {'label': option.label, 'value': option.id};
    });
  }

  @computed get integratedAppSelectOptions() {
    return this.integratedAppOptions.map((option) => {
      return {'label': option.label, 'value': option.id};
    });
  }

}


const detailsPageStore = new DetailsPageStore();
export default detailsPageStore;
export { DetailsPageStore };
